import { render, staticRenderFns } from "./stickySummary.vue?vue&type=template&id=1569dcfe&scoped=true&"
import script from "./stickySummary.vue?vue&type=script&lang=js&"
export * from "./stickySummary.vue?vue&type=script&lang=js&"
import style0 from "./stickySummary.vue?vue&type=style&index=0&id=1569dcfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1569dcfe",
  null
  
)

export default component.exports